import React from 'react';

import {labels} from '../../../../../util/utils';
import {contactListColumnIds} from '../../../../../util/uiconstants';

import CountDropdownColumn from '../../CountDropdownColumn';

const EngagementsColumn = ({item}) => {
	const list = item.engagements.map((i) => i.description);
	const props = {
		list: list.length === 0 ? [labels.manuallyAdded] : list
	};
	return <CountDropdownColumn {...props} />;
};

export const config = (labels) => ({
	id: contactListColumnIds.engagements,
	label: labels.columnEngagement,
	propName: 'eng',
	width: 'var(--px-200)',
	sortBy: [
		{propName: 'engagements', sortByField: 'description'},
		{propName: 'engagements', sortByLength: true},
		'name',
		'lastName'
	],
	customCell: (item) => {
		const props = {item};
		return <EngagementsColumn {...props} />;
	}
});
